import {BurgerMenuEntryComponentsModule}  from './burger-menu-entry-components/burger-menu-entry-components.module';
import {ColorLegendEntryComponentsModule} from './color-legend-entry-components/color-legend-entry-components.module';

export const DYNAMIC_LOAD_COMPONENTS = [
  ...BurgerMenuEntryComponentsModule.COMPONENTS,
  ...ColorLegendEntryComponentsModule.COMPONENTS,
];
